import * as React from "react"
const IconCasos = ({ width, height }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        viewBox="0 0 60 60"
        width={width}
        height={height}
    >
        <path
            d="M0 0h60v60H0z"
            style={{
                fill: "#eae0d8",
            }}
        />
        <path
            d="M1.84 1.9h56.32v56.32H1.84z"
            style={{
                fill: "none",
                stroke: "#354060",
                strokeMiterlimit: 10,
            }}
        />
        <path
            d="M29.16 12.31c13.23-.8 22.28 13.25 15.79 24.92-6.01 10.8-21.31 11.54-28.41 1.42-7.46-10.64-.28-25.56 12.62-26.34Zm1.12 1.58c-11.02.02-18.36 11.49-13.73 21.55 4.79 10.41 19.22 11.85 25.99 2.59 7.32-10.03.11-24.16-12.25-24.13Z"
            style={{
                fill: "#354060",
            }}
        />
        <path
            d="m35.34 31.39-.06.16c.01.12.03.24.05.36.2 1.48.75 3.29.81 4.73.04.85-.4 1.2-1.22.92l-4.65-2.43-4.71 2.47c-.6.23-1.09-.12-1.18-.72l.89-5.37-3.8-3.76c-.44-.54-.13-1.22.54-1.34l5.2-.79 2.36-4.75c.32-.49 1.04-.56 1.4-.08l2.48 4.85 5.09.74c.78.08 1 .92.48 1.46l-3.68 3.54Zm-4.96-8.25c-.17-.04-.12.02-.17.1-.62.95-1.06 2.31-1.62 3.32-.29.52-.4.56-.97.68-1.22.25-2.53.28-3.76.55.79 1.03 2.11 1.84 2.88 2.84.1.13.2.27.24.43l-.66 4.28 3.57-1.85c.3-.16.6-.1.89.04l3.47 1.81-.66-4.28c.05-.16.14-.3.24-.43.77-1.01 2.09-1.82 2.88-2.84-1.22-.26-2.54-.3-3.76-.55-.47-.09-.62-.1-.9-.52-.66-1.01-1.1-2.5-1.71-3.57Z"
            style={{
                fill: "#354060",
            }}
        />
    </svg>
)
export default IconCasos
